function menu_bg_remove() {
  document.querySelectorAll(".dropdown_hover").forEach((bg) => {
    bg.classList.remove("bg-light");
  });
}

function addBadgeToDeodorantLink() {
  const deodorantLink = document.querySelector(
    '.navbar .nav-item a.dropdown-item[title="Natural Solid Deodorant"]'
  );

  if (deodorantLink) {
    const badge = document.createElement("span");

    badge.className = "new-badge";

    badge.textContent = "New";

    deodorantLink.appendChild(badge);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const dropdown_hover = document.querySelectorAll(".dropdown_hover");
  dropdown_hover.forEach((dropdown) => {
    dropdown.addEventListener("mouseover", () => {
      menu_bg_remove();
      dropdown.classList.add("bg-light");
      document.querySelectorAll(".navbar-hover").forEach((navbar) => {
        navbar.querySelectorAll(".dropdown-menu").forEach((close) => {
          close.classList.remove("show");
        });
      });
      const menu = dropdown.querySelector(".dropdown-menu");
      menu.classList.add("show");
      menu.setAttribute("data-bs-popper", "static");
    });
  });
  document.querySelectorAll(".dropdown-menu").forEach((menu) => {
    menu.addEventListener("mouseout", () => {
      menu.classList.remove("show");
      menu.removeAttribute("data-bs-popper");
      menu_bg_remove();
    });
  });

  // Simple exception: close dropdown when moving to another nav link
  dropdown_hover.forEach((dropdown) => {
    dropdown.addEventListener("mouseout", (event) => {
      // Only close if moving to another dropdown item (not within the same dropdown)
      if (event.relatedTarget && event.relatedTarget.closest('.dropdown_hover') && event.relatedTarget !== dropdown) {
        const menu = dropdown.querySelector(".dropdown-menu");
        menu.classList.remove("show");
        menu.removeAttribute("data-bs-popper");
        menu_bg_remove();
      }
    });
  });

  // Close dropdown when hovering over regular nav links (non-dropdown)
  document.querySelectorAll('.navbar-nav .nav-item:not(.dropdown_hover)').forEach((navItem) => {
    navItem.addEventListener('mouseover', () => {
      // Close any open dropdown menus
      document.querySelectorAll('.navbar-hover .dropdown-menu').forEach((menu) => {
        menu.classList.remove('show');
        menu.removeAttribute('data-bs-popper');
      });
      menu_bg_remove();
    });
  });

  addBadgeToDeodorantLink();

  function updateTitles() {
    const titles = document.querySelectorAll(
      "#sca-fg-today-offer-iframe .sca-offer-title"
    );
    titles.forEach((title) => {
      const text = title.textContent || "";
      let additionalText = "";

      if (text.includes("Mouthwash")) {
        additionalText = "Spend $100 to get ";
      } else if (text.includes("Rose Water")) {
        additionalText = "Spend $150 to get ";
      } else if (text.includes("Suncare Duo")) {
        additionalText = "Spend $250 to get ";
      }

      if (additionalText && !title.dataset.modified) {
        title.textContent = additionalText + text;
        title.dataset.modified = "true";
      }
    });
  }

  function updateOffersCount(count) {
    document.querySelector('#sca-fg-today-offer-widget .sca-fg-count-offers').innerHTML = count;
  }

  function reorderOffers() {
    const container = document.querySelector(".sca-fg-offers");
    if (container) {
      const desiredOrder = ["65027", "65253", "65252"];
      const offers = Array.from(container.querySelectorAll(".sca-fg-offer"));

      offers.sort((a, b) => {
        const idA = a.getAttribute("data-fg-offer-id");
        const idB = b.getAttribute("data-fg-offer-id");
        return desiredOrder.indexOf(idA) - desiredOrder.indexOf(idB);
      });

      offers.forEach((offer, index) => {
        if (offer.dataset.order !== String(index)) {
          container.appendChild(offer);
          offer.dataset.order = String(index); // Mark as reordered
        }
      });

      updateOffersCount(desiredOrder.length);
    }
  }

  let isChecked = false;

  const observer = new MutationObserver(() => {
    const offerDiv = document.querySelector("#sca-fg-today-offer-iframe");
    if (offerDiv && !isChecked) {
      isChecked = true;

      const floatingWidgetObserver = new MutationObserver(() => {
        updateTitles();
        reorderOffers();
      });

      floatingWidgetObserver.observe(offerDiv, {
        childList: true,
        subtree: true,
      });

      updateTitles();
      reorderOffers();

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      updateTitles();
      reorderOffers();
    }
  });

  // Handle mobile nav open/close events for opacity transitions
  document.addEventListener('MobileNav:open', () => {
    const offerWidget = document.getElementById("sca-fg-today-offer-widget");
    const chatButton = document.getElementById("chat-button");
    if (offerWidget) { offerWidget.style.opacity = '0'; }
    if (chatButton) { chatButton.style.opacity = '0'; }
  });

  document.addEventListener('MobileNav:close', () => {
    const offerWidget = document.getElementById("sca-fg-today-offer-widget");
    const chatButton = document.getElementById("chat-button");
    if (offerWidget) { offerWidget.style.opacity = '1'; }
    if (chatButton) { chatButton.style.opacity = '1'; }
  });
});

document.addEventListener("animationend", function (event) {
  if (event.animationName === "klaviyo-fadeout") {
    const popup = document.querySelector(
      'div[aria-label="POPUP Form"][role="dialog"]'
    );

    if (popup) {
      popup.style.display = "none";
    }
  }
});
